@let heroBannerList = heroBanners();
@if (heroBannerList?.length) {
  <app-hero-banner id="main" tabindex="-1" [activeBanners]="heroBannerList"></app-hero-banner>
}
<div class="content">
  @if (primarySection) {
    <div class="deals-wrapper">
      @let link = primarySection.link;
      <div class="deals">
        <div class="deals-header">
          <h1>{{ primarySection.title }}</h1>
          <a [routerLink]="link.url">{{ link.name }} <mat-icon svgIcon="arrow_forward"></mat-icon></a>
        </div>
        <div class="deals-content">
          @for (product of primarySection.products | async; track $index) {
            <app-product-card [product]="product" [big]="true"></app-product-card>
          }
        </div>
      </div>
    </div>
  }
  <div class="textarea-wrapper">
    @if (topTextareaImage) {
      <img [src]="topTextareaImage | cms" alt="" />
    }
    <div class="textarea-right">
      @if (topTextarea) {
        <app-richtext-box [content]="topTextarea" [simple]="true"></app-richtext-box>
      }
      @if (topTextareaLink) {
        <app-text-button [routerLink]="topTextareaLink.Url" [target]="topTextareaLink.Target">
          {{ topTextareaLink.Name }} <mat-icon svgIcon="arrow_forward"></mat-icon>
        </app-text-button>
      }
    </div>
  </div>
  <div class="textarea-wrapper bottom">
    <div class="textarea-left">
      @if (bottomTextarea) {
        <app-richtext-box [content]="bottomTextarea" [simple]="true"></app-richtext-box>
      }
    </div>
    @if (bottomTextareaImage) {
      <img [src]="bottomTextareaImage | cms" alt="" />
    }
  </div>
</div>
